import { createSlice } from '@reduxjs/toolkit';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';

const initialState = {
  knowledgeBase: [],
  loading: false,
  error: null,
};

const knowledgeBaseSlice = createSlice({
  name: 'knowledgeBase',
  initialState,
  reducers: {
    setKnowledgeBase: (state, action) => {
      state.knowledgeBase = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setKnowledgeBase, setLoading, setError } =
  knowledgeBaseSlice.actions;

export const createKnowledgeBase = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const kbRef = collection(db, 'knowledgeBase');
    const docRef = await addDoc(kbRef, {
      ...data,
      createdAt: new Date(),
      updatedAt: new Date(),
    });
    dispatch(setLoading(false));
    return docRef.id;
  } catch (error) {
    dispatch(setError(error.message));
    dispatch(setLoading(false));
    throw error;
  }
};

export default knowledgeBaseSlice.reducer;
